import facturacionRoutes from '../apps/facturacion/routes'
import facturacionCompraRoutes from '../apps/facturacion_compra/routes'
import sofonoRoutes from '../apps/sofono/routes'
import preSofonoRoutes from '../apps/preSofono/routes'
import cotizacionesRoutes from '../apps/cotizaciones/routes'
import serviciosRoutes from '../apps/servicios/routes'
import NotasCobro from '../apps/notas_cobro/routes'
import bandejaRoutes from '../apps/bandeja/routes'
import webpayRoutes from '../apps/webpay/routes'
import devolucionesRoutes from '../apps/devoluciones/routes'
import automatizacionesRoutes from '../apps/automatizaciones/routes'
import clientesRoutes from '../apps/clientes/routes'



export default [
  {
    path: '/facturacion',
    component: () => import(/* webpackChunkName: "apps-facturacion" */ '@/apps/facturacion/FacturacionApp.vue'),
    children: [
      ...facturacionRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/facturacion-compra',
    component: () => import(/* webpackChunkName: "apps-facturacion" */ '@/apps/facturacion_compra/FacturacionCompraApp.vue'),
    children: [
      ...facturacionCompraRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/notas-cobros',
    component: () => import(/* webpackChunkName: "apps-notas_cobro" */ '@/apps/notas_cobro/notasCobroApp.vue'),
    children: [
      ...NotasCobro
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/webpay',
    component: () => import(/* webpackChunkName: "apps-webpay" */ '@/apps/webpay/WebpayApp.vue'),
    children: [
      ...webpayRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/sofono',
    component: () => import(/* webpackChunkName: "apps-sofono" */ '@/apps/sofono/SofonoApp.vue'),
    children: [
      ...sofonoRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/pre-sofono',
    component: () => import(/* webpackChunkName: "apps-pre-sofono" */ '@/apps/preSofono/PreSofonoApp.vue'),
    children: [
      ...preSofonoRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/cotizaciones',
    component: () => import(/* webpackChunkName: "apps-cotizaciones" */ '@/apps/cotizaciones/CotizacionesApp.vue'),
    children: [
      ...cotizacionesRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/apps/servicios',
    component: () => import(/* webpackChunkName: "apps-board" */ '@/apps/servicios/ServiciosApp.vue'),
    children: [
      ...serviciosRoutes
    ]
  },
  {
    path: '/bandeja',
    component: () => import(/* webpackChunkName: "apps-bandeja" */ '@/apps/bandeja/BandejaApp.vue'),
    children: [
      ...bandejaRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/devoluciones',
    component: () => import(/* webpackChunkName: "apps-devoluciones" */ '@/apps/devoluciones/DevolucionesApp.vue'),
    children: [
      ...devolucionesRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/automatizaciones',
    component: () => import(/* webpackChunkName: "apps-automatizaciones" */ '@/apps/automatizaciones/AutomatizacionesApp.vue'),
    children: [
      ...automatizacionesRoutes
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/clientes',
    component: () => import(/* webpackChunkName: "apps-clientes" */ '@/apps/clientes/ClientesApp.vue'),
    children: [
      ...clientesRoutes
    ],
    meta: { requiresAuth: true }
  }
]
